import React, { useState } from 'react';
import { RadioGroup, FormControlLabel, Radio, TextField, Typography } from '@mui/material';
import { GRADE_LABELS } from '../../../utils/formatter';
import AdminBulkDialog from './AdminBulkDialog';

const REASONS = [
  '성인/도박 등 불법광고 및 스팸 활동',
  '바람직하지 않은 활동(광고, 도배, 욕설, 비방 등)',
];
const TITLES = {
  grade: '등급 변경',
  suspend: '활동 정지',
  reactivate: '활동 정지 해제',
  withdraw: '강제 탈퇴',
  rejoin: '상태 변경',
};

// Parent mounts a fresh form for each captured confirmation; failed requests
// leave this form mounted so reasons/options are not silently reset.
export default function AdminUserActionDialog({ action, onConfirm }) {
  const { kind, currentGrade } = action.confirmation;
  const [reason, setReason] = useState(REASONS[0]);
  const [other, setOther] = useState('');
  const [grade, setGrade] = useState(currentGrade || Object.keys(GRADE_LABELS)[0]);
  const [rejoinable, setRejoinable] = useState(false);
  const hasReason = kind === 'suspend' || kind === 'withdraw';
  const value = hasReason
    ? reason === 'other'
      ? other.trim()
      : reason
    : kind === 'grade'
      ? grade
      : rejoinable;
  const choice = (v, label) => (
    <FormControlLabel
      key={v}
      value={v}
      control={<Radio size="small" disabled={action.busy} />}
      label={label}
      sx={{
        '& .MuiFormControlLabel-label': { fontSize: 14, minWidth: 0 },
        alignItems: 'center',
        '@container (max-width: 200px)': {
          flexDirection: 'column',
          alignItems: 'flex-start',
          mx: 0,
          mb: 2,
          '& .MuiRadio-root': { p: 0, mb: 0.5 },
          '& .MuiFormControlLabel-label': { width: '100%' },
        },
      }}
    />
  );
  return (
    <AdminBulkDialog
      action={action}
      title={TITLES[kind]}
      onConfirm={() => onConfirm(value)}
      disabled={hasReason && !value}
      confirmText={hasReason ? TITLES[kind] : '변경'}
    >
      {hasReason && (
        <>
          <Typography sx={{ mb: 2 }}>{TITLES[kind]} 사유</Typography>
          <RadioGroup aria-label="사유" value={reason} onChange={(e) => setReason(e.target.value)}>
            {REASONS.map((r) => choice(r, r))}
            {choice('other', '기타 사유')}
          </RadioGroup>
          <TextField
            label="기타 사유"
            multiline
            minRows={2}
            fullWidth
            value={other}
            disabled={action.busy || reason !== 'other'}
            onChange={(e) => setOther(e.target.value)}
          />
        </>
      )}
      {kind === 'grade' && (
        <RadioGroup aria-label="등급" value={grade} onChange={(e) => setGrade(e.target.value)}>
          {Object.entries(GRADE_LABELS).map(([v, label]) => choice(v, label))}
        </RadioGroup>
      )}
      {kind === 'reactivate' && (
        <Typography>선택된 회원을 활동 멤버로 변경하시겠습니까?</Typography>
      )}
      {kind === 'rejoin' && (
        <RadioGroup
          aria-label="재가입 상태"
          value={rejoinable ? 'yes' : 'no'}
          onChange={(e) => setRejoinable(e.target.value === 'yes')}
        >
          {choice('no', '가입불가')}
          {choice('yes', '가입가능')}
        </RadioGroup>
      )}
    </AdminBulkDialog>
  );
}
